var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Avatar } from 'modules/v2/dataDisplay/Avatar';
import { AvatarLabel } from './AvatarLabel';
import { Container } from './styled';
export function AvatarWithLabel(props) {
    const { title, subtitle, size = 'lg', className, alignment = 'horizontal', truncate = true, avatarTooltip, labelTooltip, withLabel = true, appearance, shape, solid } = props, restProps = __rest(props, ["title", "subtitle", "size", "className", "alignment", "truncate", "avatarTooltip", "labelTooltip", "withLabel", "appearance", "shape", "solid"]);
    return (<Container $alignment={alignment} $size={size} className={className}>
      <Avatar size={size} tooltip={avatarTooltip} appearance={appearance} shape={shape} solid={solid} {...restProps}/>
      {withLabel && <AvatarLabel title={title} subtitle={subtitle} truncate={truncate} labelTooltip={labelTooltip}/>}
    </Container>);
}
